import { useEffect } from 'react';
import { Typography } from '@tempmee/react';
import { colors } from '@tempmee/tailwind';
import { useAppSelector } from '~/hooks/useAppSelector';
import { Center, Row } from '../../../../commonComponents';
import browserHistory from '../../../../browserHistory';
import activeStep from '../../../../images/progressBarMDB/activeStep.svg';
import firstStep from '../../../../images/progressBarMDB/greenSolidCircle.svg';
import inactiveStep from '../../../../images/progressBarMDB/inactiveStep.svg';

interface IStepProps {
  title: string;
  active: boolean;
  isFirstStep?: boolean;
}

const Step = ({ title, active, isFirstStep = false }: IStepProps) => (
  <Row
    style={{
      alignItems: 'center',
    }}
  >
    {isFirstStep && <img src={firstStep} alt={title} />}
    {!isFirstStep && active && <img src={activeStep} alt={title} />}
    {!isFirstStep && !active && <img src={inactiveStep} alt={title} />}
    <Typography as="span" color={active ? colors.neutral[600] : colors.neutral[300]} style={{ marginLeft: 4 }}>
      {title}
    </Typography>
  </Row>
);

interface IProgressBarProps {
  step: number;
  title?: string;
  isHidden?: boolean;
}

/**
 * @deprecated ProgressBar is deprecated. Please use the Stepper component instead.
 * The Stepper component provides better functionality and follows current design patterns.
 */
export const ProgressBar = ({
  step,
  title = 'Professional Request / Re-Book',
  isHidden = false,
}: IProgressBarProps) => {
  const jobDates = useAppSelector((state) => state.multiday.jobDates);

  useEffect(() => {
    window.scrollTo(0, 0);

    if (jobDates === null && step > 1) {
      browserHistory.replace('/dashboard/multi-day/info');
    }
  }, [step, jobDates]);

  return (
    <Center marginBottom={32}>
      <Typography as="span" bold size="heading_2" textAlign="center">
        {title}
      </Typography>

      {!isHidden && (
        <Row
          style={{
            alignItems: 'center',
            justifyContent: 'center',
            height: 30,
            gap: '4px',
            marginTop: 24,
          }}
        >
          <Step title="Shift Details" active isFirstStep />
          <Step title="Review and Confirm" active={step >= 2} />
        </Row>
      )}
    </Center>
  );
};
